<template>
    <div class="footer">
      <div class="contentW" style="position: relative;text-align:left;">
        <!-- 临时隐藏协议 -->
        <!-- <div class="privacy_link" @click="navClick2('/privacy')">Privacy & Disclosure</div> -->
        <div class="uline"></div>
        <div class="privacy">
          Supay Technology Pty Ltd. Authorized Representative Number 001283947
        </div>
        <div class="goTopBtn" @click="toTop">
          <img src="../assets/icon/goTopIcon.png" />
        </div>
      </div>
    </div>
</template>
<script>
let timer = null; //定义初始值
export default {
  name: 'Footer',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  methods:{
    toTop() {
      // 动画

      timer = setInterval(function() {
        let osTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed;
        // this.isTop = true
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 30);
    },
    navClick2(url) {
      this.$router.push(url);
    },
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;

      var offsetTop1 = document.querySelector("#m1").offsetTop;
      var offsetTop2 = document.querySelector("#m2").offsetTop;
      var offsetTop3 = document.querySelector("#m3").offsetTop;

      if (scrollTop > offsetTop1 - 600) {
        this.mm1 = true;
      } else {
        this.mm1 = false;
      }
      if (scrollTop > offsetTop2 - 600) {
        this.mm2 = true;
      } else {
        this.mm2 = false;
      }
      if (scrollTop > offsetTop3 - 600) {
        this.mm3 = true;
      } else {
        this.mm3 = false;
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.uline{
  /* height:1px; */
  margin-top: 24px;
  border-bottom: #4a4a4a 1px solid;
}
.privacy {
  /* border-top: #4a4a4a 1px solid; */
  margin-top: 24px;
}
.privacy_link{
  cursor: pointer;
  color:rgba(255,255,255,1);
}
</style>